import { Box, Typography, useMediaQuery } from "@mui/material";

import BackGroundLogo from "../../../assets/images/BackGround.png";
import responsive from "../../../assets/css/responsive";
import WeHearLogo from "../../../assets/images/WEHEARHRMSLOGIN.png";
import LogoImage from "../../../assets/images/logo1.png";

import { mode } from "../../../apis/endpoints";
const outerBoxStyle = (theme) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    flexDirection: "column",
    background: "#FFFFFF",
    ...responsive.outerBoxStyle,
  };
};

const heading = {
  fontFamily: "Azonix Regular",
  src: `local('Azonix Regular'), url('../../../assets/fonts/azonix-cufonfonts-webfont/Azonix.woff') format('woff')`,
  fontSize: "48px",
  fontWeight: 400,
  lineHeight: "60px",
  letterSpacing: "0.315em",
  color: "#FFFFFF",
};

const BackGroundStyle = {
  background: `url(${BackGroundLogo})`,
  objectFit: "cover",
  width: "100%",
};

const text = {
  fontFamily: "Azonix",
  fontFamily: "Azonix Regular",
  src: `local('Azonix Regular'), url('../../../assets/fonts/azonix-cufonfonts-webfont/Azonix.woff') format('woff')`,
  fontWeight: 400,
  fontSize: "24px",
  lineHeight: "32px",
  letterSpacing: "0.315em",
  color: "#FFFFFF",
};

const weHearLoginLogoBox = {
  width: "296px",
  height: "43px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  flexDirection: "column",
  ...responsive.weHearLogoBox,
};

const weHearLoginLogoImg = {
  width: "458px",
  height: "314px",
}
const AuthLeftContainer = () => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"))

  return (
    <Box>
      <Box sx={outerBoxStyle}>
        <Box sx={isSmallScreen ? weHearLoginLogoBox : ""}>
          <Box mb={6}>
            <img src={LogoImage} alt="QUANTUMHRMS" style={weHearLoginLogoImg} />
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </Box>
  );
};
export default AuthLeftContainer;
